import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "../utils";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

const devicesSettingsV2Api = createApi({
  reducerPath: "devicesSettingsV2Api",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  tagTypes: ["DeviceSettingsV2", "EspressoBeverages", "OkcSettings"],
  keepUnusedDataFor: 60,
  endpoints(builder) {
    return {
      readDeviceSettingsV2: builder.query({
        query: (data) =>
          apiFunction(
            data,
            "/api/devices/storageRoles/v2/settings/read",
            "POST",
          ),
        transformResponse: (response) => {
          return response?.data ?? response;
        },
        providesTags: (result, error, arg) => [
          { type: "DeviceSettingsV2", id: arg.id },
        ],
      }),
      writeDeviceSettingsV2: builder.mutation({
        query: (data) =>
          apiFunction(
            data,
            "/api/devices/storageRoles/v2/settings/write",
            "POST",
          ),
        transformResponse: (response) => response?.data ?? response,
        // NOT: invalidatesTags bilinçli olarak KALDIRILDI. Kaydetten hemen sonra
        // tetiklenen otomatik refetch, cihaz henüz ayarı senkronlamadığı için
        // eski/gecikmeli değeri okuyup optimistik update'i eziyordu (kullanıcı
        // sayfayı yenilemeden yeni değeri göremiyordu). handleSave artık cihazın
        // kabul ettiği değerleri optimistik olarak cache'e yazıyor; taze veri
        // gerektiğinde manuel "Yenile" (refetch) kullanılıyor.
      }),
      // OKC (eski kart seti Türk kahvesi) ayarları — #325, okc-settings.md.
      // Şema sunucudan gelir; makine yalnız değer taşır.
      readOkcSettings: builder.query({
        query: (data) =>
          apiFunction(data, "/api/devices/storageRoles/okc/settings/read", "POST"),
        transformResponse: (response) => response?.data ?? response,
        providesTags: (result, error, arg) => [{ type: "OkcSettings", id: arg.id }],
      }),
      // Kabul edilen değerler sekmede iyimser yazılır (v2 ile aynı gerekçe:
      // otomatik refetch makinenin henüz eşitlemediği değeri okuyabilir).
      writeOkcSettings: builder.mutation({
        query: (data) =>
          apiFunction(data, "/api/devices/storageRoles/okc/settings/write", "POST"),
        transformResponse: (response) => response?.data ?? response,
      }),
      // Espresso içecek listesi (Kalerm 2.4) — her açılışta server senkronlar.
      readEspressoBeverages: builder.query({
        query: (data) =>
          apiFunction(
            data,
            "/api/devices/storageRoles/espresso/beverages",
            "POST",
          ),
        transformResponse: (response) => response?.data ?? response,
        providesTags: (result, error, arg) => [
          { type: "EspressoBeverages", id: arg.id },
        ],
      }),
      // Espresso QR ödeme kodu (server PNG data URL üretir). data: { token, id }
      readEspressoPaymentQr: builder.query({
        query: (data) =>
          apiFunction(
            data,
            "/api/devices/storageRoles/espresso/payment-qr",
            "POST",
          ),
        transformResponse: (response) => response?.data ?? response,
      }),
      // İçecek fiyatı güncelle (kuruş).
      updateEspressoBeveragePrice: builder.mutation({
        query: (data) =>
          apiFunction(
            data,
            "/api/devices/storageRoles/espresso/beverages/price",
            "PATCH",
          ),
        transformResponse: (response) => response?.data ?? response,
        invalidatesTags: (result, error, arg) => [
          { type: "EspressoBeverages", id: arg.id },
        ],
      }),
    };
  },
});

export const {
  useReadDeviceSettingsV2Query,
  useWriteDeviceSettingsV2Mutation,
  useReadOkcSettingsQuery,
  useWriteOkcSettingsMutation,
  useReadEspressoBeveragesQuery,
  useReadEspressoPaymentQrQuery,
  useUpdateEspressoBeveragePriceMutation,
} = devicesSettingsV2Api;
export { devicesSettingsV2Api };
